import React from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import TextAreaField from 'shared-components/reduxForms/fields/TextAreaField/TextAreaField';
import { SEND_OFFER_FORM } from '../../constants/formNames';
import submitSendOfferForm from '../../submit/submitSendOfferForm';
import validateSendOfferForm from '../../validate/validateSendOfferForm';
import Button from '../../../../../elements-buttons/Button';
import { TosCTAdisclaimer } from 'shared-components/terms/cta-disclaimer';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
import TrustAndSafetyWarning from '../../../../../app-bookings-request/TrustAndSafetyWarning';

const SendOfferForm = ({
  handleSubmit,
  isSubmitting,
  guestName,
  navigateBack,
  isHostUpdate,
  errorMessage,
  contractData,
  submitOffer,
  showTSWarning,
  isTSAccepted,
  setIsTSAccepted,
  intl
}) => {
  const submitForm = (event) => {
    event.preventDefault();
    submitOffer(handleSubmit(submitSendOfferForm));
  };

  return (
    <form className="send-offer-form" onSubmit={submitForm}>
      <h6 className="flex header">
        <span>
          <FormattedMessage
            id='inbox.send_offer_form.updated'
            defaultMessage='Include a message to your guest'
          />
          <span className="required">*</span>
        </span>
      </h6>
      <Field
        name="message"
        component={TextAreaField}
        className="form-fields"
        placeholder={ intl.formatMessage({ id: 'inbox.send_offer_form.changes', defaultMessage: 'Explain any changes or additional booking details...' }) }
        maxHeight={92}
        attributes={{ 'data-testing-id': 'message-field' }}
      />
      <div className="margin-lg-bottom">
        <h6>
          <FormattedMessage id='inbox.send_offer_form.whats_next' defaultMessage='What’s next?' />
        </h6>
        <p>{ isHostUpdate
          ? <span data-testing-id="host-msg"><FormattedMessage id='inbox.send_offer_form.guest_respond' defaultMessage='The guest will have up to 7 days to respond to your request before it expires. If it expires or gets declined, your booking will revert to the original details.' /></span>
          : <span data-testing-id="guest-msg"><FormattedMessage id='inbox.send_offer_form.guest_review' defaultMessage='The guest has up to 7 days to review the offer. If they accept, the booking will be confirmed. If they decline or you withdraw it, you can create a new offer.' /></span>
        }
        </p>
      </div>
      <hr />
      <div className="help-block text-danger text-right">{ errorMessage && <FormattedMessage id='inbox.send_offer_form.something_wrong' defaultMessage='Something went wrong, please try again.' /> }</div>
      { showTSWarning
        && <div className="ts-warning-wrap">
          <TrustAndSafetyWarning isAccepted={isTSAccepted} setIsAccepted={setIsTSAccepted} />
        </div>
      }
      <div className="form-ctas flex space-between">
        <Button
          category="default"
          type="button"
          onClick={navigateBack}
          attributes={{ 'data-testing-id': 'back-btn' }}
        >
          <FormattedMessage
            id='inbox.send_offer_form.back'
            defaultMessage='Back'
          />
        </Button>
        <Button
          category="primary"
          isLoading={isSubmitting}
          disabled={(showTSWarning && !isTSAccepted)}
          attributes={{ 'data-testing-id': 'send-custom-offer-btn' }}
        >
          <FormattedMessage
            id='inbox.send_offer_form.send_offer'
            defaultMessage='Send'
          />
        </Button>
      </div>
      <hr className="no-bottom-margin" />
      <TosCTAdisclaimer
        location="requestBkgNewTab"
        buttonLabel={ intl.formatMessage({ id: 'inbox.send_offer_form.send_custom', defaultMessage: 'Send' }) }
      />
    </form>
  );
};

SendOfferForm.propTypes = {
  handleSubmit: PropTypes.func,
  guestName: PropTypes.string,
  isSubmitting: PropTypes.bool,
  navigateBack: PropTypes.func,
  isHostUpdate: PropTypes.bool,
  errorMessage: PropTypes.bool,
  submitOffer: PropTypes.func,
  intl: intlShape
};

const config = {
  form: SEND_OFFER_FORM,
  validate: validateSendOfferForm
};

export default injectIntl(reduxForm(config)(SendOfferForm));
